module.exports = __webpack_public_path__ + "img/arrow-down-left.22412036.svg";